import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}
      <div className="sticky top-0 bg-black/80 backdrop-blur-sm border-b border-white/10 px-6 py-4 z-10">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Button
            onClick={() => navigate(-1)}
            variant="ghost"
            className="text-white hover:bg-white/10 p-2"
          >
            <ArrowLeft className="w-5 h-5" />
          </Button>
          <h1 className="text-xl font-bold">Política de Privacidad</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-8">
        <div className="prose prose-invert max-w-none space-y-6 text-[#E0E0E2]">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-white mb-2">
              AVISO DE PRIVACIDAD DEL PROGRAMA "MIEMBROS PREMIER"
            </h2>
          </div>

          <div className="space-y-6 text-sm leading-relaxed">
            <p className="text-[#E0E0E2]">
              Iván Hidalgo Henaine, por su propio derecho y como titular y operador del programa "Miembros Premier", en adelante "LA ENTIDAD", "MIEMBROS PREMIER" o "EL OPERADOR", con domicilio en [DOMICILIO COMPLETO], es responsable del tratamiento, uso y protección de los datos personales que el usuario (en adelante, "EL USUARIO") proporcione, de conformidad con lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).
            </p>
            <p className="text-[#E0E0E2]">
              Este Aviso se emite para dar cumplimiento a los artículos 8, 15, 16 y demás relativos de la LFPDPPP.
            </p>
            <p className="text-[#E0E0E2]">
              El uso de la plataforma digital de Miembros Premier, sus aplicaciones, sistemas de QR dinámico, sistemas antifraude y cualquier servicio asociado, implica la aceptación expresa del presente Aviso.
            </p>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">1. Responsable del Tratamiento</h3>
              <div className="space-y-2 pl-4">
                <p className="text-[#E0E0E2]">
                  <strong>1.1.</strong> El Operador será responsable de la recopilación, uso, protección, almacenamiento y transferencia de sus datos personales.
                </p>
                <p className="text-[#E0E0E2]">
                  <strong>1.2.</strong> El tratamiento se realizará conforme a los principios de licitud, consentimiento, información, calidad, finalidad, lealtad, proporcionalidad y responsabilidad.
                </p>
                <p className="text-[#E0E0E2]">
                  <strong>1.3.</strong> Al proporcionar sus datos mediante la plataforma, usted otorga su consentimiento para el tratamiento conforme a este Aviso.
                </p>
                <p className="text-[#E0E0E2]">
                  <strong>1.4.</strong> El tratamiento se regirá siempre por la versión vigente de este Aviso de Privacidad.
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">2. Datos Personales que Recabamos</h3>
              <p className="text-[#E0E0E2]">
                EL USUARIO acepta entregar a LA ENTIDAD, para su tratamiento, los siguientes datos personales, de manera enunciativa mas no limitativa, pudiendo incluir datos adicionales siempre que sean de naturaleza similar y no excesiva.
              </p>
              
              <div className="space-y-3 pl-4">
                <div>
                  <h4 className="font-semibold text-white mb-2">A. DATOS DE IDENTIFICACIÓN</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Nombre(s), Apellidos</li>
                    <li>Fecha de nacimiento</li>
                    <li>Género (opcional)</li>
                    <li>Identificador único dentro de la plataforma</li>
                    <li>Fotografía (opcional, para perfil o validación)</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">B. DATOS DE CONTACTO</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Domicilio completo: calle, número exterior/interior, colonia, código postal, municipio/estado y país</li>
                    <li>Teléfono celular</li>
                    <li>Correo electrónico</li>
                    <li>Domicilio fiscal (cuando se requiera emitir factura)</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">C. DATOS FINANCIEROS Y TRANSACCIONES</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>RFC</li>
                    <li>Historial de pagos, cargos automáticos, renovaciones y fallas de cobro</li>
                    <li>Información generada por Stripe, incluyendo:
                      <ul className="list-circle list-inside ml-6 mt-1">
                        <li>Token de tarjeta</li>
                        <li>Últimos cuatro dígitos</li>
                        <li>Tipo/marca de tarjeta</li>
                        <li>Identificador de método de pago</li>
                      </ul>
                    </li>
                    <li>Montos pagados, fechas, autorizaciones y referencias</li>
                  </ul>
                  <p className="text-[#F4A261] font-semibold mt-2">
                    IMPORTANTE: Miembros Premier NO almacena, NO procesa ni tiene acceso a números completos de tarjetas de crédito o débito. Los datos son enviados directamente a Stripe, plataforma certificada PCI-DSS Nivel 1.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">D. DATOS TÉCNICOS Y DEL DISPOSITIVO</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Dirección IP</li>
                    <li>Sistema operativo y versión</li>
                    <li>Modelo del dispositivo</li>
                    <li>Navegador</li>
                    <li>Identificador de notificaciones PUSH</li>
                    <li>Cookies, web beacons y tecnologías similares</li>
                    <li>Fecha y hora de acceso al sistema</li>
                    <li>Logs de actividad</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">E. DATOS DE UBICACIÓN</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Ubicación geográfica (latitud y longitud) cuando EL USUARIO la autoriza</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">Utilizada para:</p>
                  <ul className="list-circle list-inside space-y-1 text-[#E0E0E2] ml-6">
                    <li>Mostrar beneficios cercanos</li>
                    <li>Sistemas antifraude</li>
                    <li>Validar activación de códigos QR</li>
                    <li>Análisis estadístico de zonas</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">F. DATOS DERIVADOS DE CÓDIGOS QR</h4>
                  <p className="text-[#E0E0E2] mb-2">Cada vez que EL USUARIO escanea un código QR, LA ENTIDAD recoge:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Identificador del QR</li>
                    <li>Marca o comercio afiliado</li>
                    <li>Fecha y hora del escaneo</li>
                    <li>Ubicación del escaneo (si está activada)</li>
                    <li>Dispositivo utilizado</li>
                    <li>Resultado de validación del QR</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">
                    Esta información permite operar el sistema antifraude, validar membresías y aplicar beneficios.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">G. DATOS DE USO Y COMPORTAMIENTO</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Historial de activación de beneficios</li>
                    <li>Frecuencia de uso</li>
                    <li>Establecimientos visitados</li>
                    <li>Preferencias de consumo</li>
                    <li>Segmentación por hábitos</li>
                    <li>Métricas de comportamiento dentro de la app</li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">3. Finalidades del Tratamiento</h3>
              
              <div>
                <h4 className="font-semibold text-white mb-2">3.1 Finalidades Primarias (indispensables para la relación jurídica)</h4>
                <p className="text-[#E0E0E2] mb-2">Sus datos serán utilizados para:</p>
                <ol className="list-decimal list-inside space-y-1 text-[#E0E0E2] ml-4">
                  <li>Registrar al Usuario en el Programa y administrar su cuenta.</li>
                  <li>Procesar pagos, renovaciones automáticas y cargos recurrentes mediante Stripe.</li>
                  <li>Validar identidad y datos del Usuario, incluido domicilio, para facturación y seguridad.</li>
                  <li>Generar, autenticar y actualizar códigos QR dinámicos para otorgar beneficios.</li>
                  <li>Verificar membresía vigente ante Marcas Afiliadas y permitir acceso a beneficios.</li>
                  <li>Compartir con Marcas Afiliadas exclusivamente la información necesaria para aplicar beneficios.</li>
                  <li>Proporcionar soporte técnico, atención al cliente y gestión de aclaraciones.</li>
                  <li>Emitir facturas, comprobantes y documentación asociada a la membresía.</li>
                  <li>Implementar mecanismos de seguridad, prevención de fraude y monitoreo de uso indebido.</li>
                  <li>Mantener y mejorar la operación de la plataforma, infraestructura tecnológica y nuevas funciones.</li>
                  <li>Cumplir con obligaciones legales, fiscales y administrativas aplicables.</li>
                  <li>Registrar y gestionar historial de membresías, pagos y uso del Programa.</li>
                  <li>Desarrollar métricas internas, análisis operativos y herramientas para optimizar el Programa.</li>
                  <li>Realizar estudios de mercado, análisis de desempeño de comercios participantes y evaluación del comportamiento de usuarios dentro del Programa.</li>
                </ol>
              </div>

              <div>
                <h4 className="font-semibold text-white mb-2">3.2 Finalidades Secundarias</h4>
                <ol className="list-decimal list-inside space-y-1 text-[#E0E0E2] ml-4">
                  <li>Enviar promociones personalizadas y contenido comercial.</li>
                  <li>Enviar promociones, beneficios y campañas conjuntas realizadas con Marcas Afiliadas.</li>
                  <li>Analizar comportamiento del Usuario y preferencias de consumo con fines mercadológicos.</li>
                  <li>Elaborar estudios de mercado, métricas estadísticas y segmentación comercial.</li>
                  <li>Comunicar nuevas Marcas Afiliadas, beneficios o actualizaciones del Programa.</li>
                  <li>Elaborar perfiles de uso (sin incluir datos financieros).</li>
                  <li>Invitar al Usuario a encuestas, pruebas de experiencia o evaluaciones de satisfacción.</li>
                </ol>
                <p className="text-[#E0E0E2] mt-2">
                  El Usuario podrá solicitar en cualquier momento la exclusión de estas finalidades enviando un correo a [CORREO].
                </p>
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">4. Fuentes de Obtención de Datos</h3>
              <p className="text-[#E0E0E2]">
                LA ENTIDAD podrá obtener datos personales de EL USUARIO a través de las siguientes fuentes, mecanismos y tecnologías, de manera enunciativa más no limitativa:
              </p>
              
              <div className="space-y-3 pl-4">
                <div>
                  <h4 className="font-semibold text-white mb-2">4.1. Datos proporcionados directamente por EL USUARIO</h4>
                  <p className="text-[#E0E0E2] mb-2">A través de:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Formularios de registro</li>
                    <li>Creación de cuenta</li>
                    <li>Procesamiento de pago o actualización de método de pago</li>
                    <li>Solicitudes de soporte, aclaraciones o quejas</li>
                    <li>Actualización voluntaria de datos (domicilio, teléfono, RFC, etc.)</li>
                    <li>Activación de promociones o beneficios</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">
                    Incluye toda la información ingresada manualmente o transmitida voluntariamente por EL USUARIO.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">4.2. Datos generados automáticamente por la plataforma digital</h4>
                  <p className="text-[#E0E0E2] mb-2">
                    LA ENTIDAD recolecta información generada al usar la aplicación, sistema o sitio web, incluyendo:
                  </p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Cookies y tecnologías de rastreo</li>
                    <li>Web beacons</li>
                    <li>Logs de acceso</li>
                    <li>Dirección IP</li>
                    <li>Datos de navegación y tiempos de sesión</li>
                    <li>Identificadores únicos del dispositivo</li>
                    <li>Identificadores PUSH</li>
                    <li>Versión de la app o navegador</li>
                    <li>Fallos, errores, cierres inesperados o eventos técnicos relevantes</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">Esto se utiliza para:</p>
                  <ul className="list-circle list-inside space-y-1 text-[#E0E0E2] ml-6">
                    <li>Funcionamiento operativo</li>
                    <li>Seguridad informática</li>
                    <li>Personalización del servicio</li>
                    <li>Analítica estadística</li>
                    <li>Prevención de fraude digital</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">4.3. Datos derivados del uso de Códigos QR</h4>
                  <p className="text-[#E0E0E2] mb-2">
                    Cuando EL USUARIO escanea un código QR vinculado a Miembros Premier:
                  </p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Se identifica el QR escaneado</li>
                    <li>Se registra la hora y fecha exacta</li>
                    <li>Se identifica el comercio afiliado asociado</li>
                    <li>Se vincula con la cuenta del Usuario</li>
                    <li>Se recaba ubicación geográfica (si está habilitada)</li>
                    <li>Se registra el dispositivo utilizado</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">Estos datos se utilizan para:</p>
                  <ul className="list-circle list-inside space-y-1 text-[#E0E0E2] ml-6">
                    <li>Validación de beneficios</li>
                    <li>Prevención de fraude (dobles activaciones, QR falsos, uso indebido)</li>
                    <li>Registro de operaciones</li>
                    <li>Auditoría interna</li>
                    <li>Análisis del desempeño de establecimientos afiliados</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">4.4. Datos obtenidos por terceros autorizados</h4>
                  <p className="text-[#E0E0E2] mb-2">LA ENTIDAD puede recibir datos de:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Stripe, respecto a estado de pagos, tokens, método de pago, autorizaciones, rechazos y renovaciones</li>
                    <li>Proveedores de autenticación, mensajería y notificaciones</li>
                    <li>Sistemas de hosting, servidores y bases de datos en la nube</li>
                    <li>Proveedores de análisis y métricas (sin datos sensibles)</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">
                    Estos datos se integran a los expedientes del Usuario exclusivamente para fines operativos, antifraude, facturación y administración del Programa.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">4.5. Datos obtenidos de fuentes permitidas por la Ley</h4>
                  <p className="text-[#E0E0E2] mb-2">LA ENTIDAD podrá obtener datos de:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Directorios públicos</li>
                    <li>Bases de datos accesibles al público</li>
                    <li>Información comercial no restringida</li>
                    <li>Datos suministrados por terceros cuando exista relación con el Usuario</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">
                    Siempre que tales fuentes sean lícitas y respeten la finalidad compatible con este Aviso.
                  </p>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">5. Transferencia de Datos Personales</h3>
              <p className="text-[#E0E0E2]">
                EL USUARIO acepta que LA ENTIDAD podrá transferir o remitir datos personales a terceros bajo las siguientes categorías:
              </p>
              
              <div className="space-y-3 pl-4">
                <div>
                  <h4 className="font-semibold text-white mb-2">5.1. Proveedores esenciales</h4>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Stripe (procesamiento de pagos)</li>
                    <li>Servicios de hosting, servidores y bases de datos</li>
                    <li>Plataformas de correo, SMS y notificaciones push</li>
                    <li>Servicios antifraude</li>
                    <li>Proveedores de sistemas de código QR</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">
                    Actúan siguiendo instrucciones de LA ENTIDAD bajo contratos de confidencialidad.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">5.2. Marcas Afiliadas</h4>
                  <p className="text-[#E0E0E2] mb-2">Para activar beneficios, solo se compartirá:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Nombre del Usuario</li>
                    <li>Tipo y estatus de membresía</li>
                    <li>Vigencia</li>
                    <li>Información derivada del QR escaneado</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">5.3. Cumplimiento normativo</h4>
                  <p className="text-[#E0E0E2] mb-2">Se transferirá información a:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Autoridades fiscales</li>
                    <li>Autoridades administrativas o judiciales</li>
                    <li>Reguladores</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">Solo cuando exista requerimiento legal.</p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">5.4. Transferencias corporativas internas</h4>
                  <p className="text-[#E0E0E2] mb-2">En caso de:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Fusión</li>
                    <li>Escisión</li>
                    <li>Adquisición</li>
                    <li>Transmisión de activos</li>
                    <li>Reestructuración corporativa</li>
                  </ul>
                  <p className="text-[#E0E0E2] mt-2">
                    Los datos podrán ser transferidos a entidades pertenecientes al mismo grupo empresarial.
                  </p>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">5.5. Promociones conjuntas</h4>
                  <p className="text-[#E0E0E2]">
                    EL USUARIO autoriza que, cuando participe en promociones conjuntas, se compartan:
                  </p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Nombre</li>
                    <li>Correo</li>
                    <li>Preferencia manifestada</li>
                    <li>Datos estadísticos no sensibles</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-white mb-2">5.6. Sistemas antifraude y seguridad</h4>
                  <p className="text-[#E0E0E2] mb-2">Se podrán compartir datos para:</p>
                  <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                    <li>Validación de identidad</li>
                    <li>Verificación de transacciones</li>
                    <li>Detección de duplicidades</li>
                    <li>Prevención de actividades irregulares</li>
                  </ul>
                </div>

                <div>
                  <h4 className="font-semibold text-[#F4A261] mb-2">5.7. Prohibición expresa</h4>
                  <p className="text-[#F4A261] font-semibold">
                    LA ENTIDAD no vende, no renta ni comercializa datos personales.
                  </p>
                </div>
              </div>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">6. Seguridad de Datos Personales</h3>
              <p className="text-[#E0E0E2] mb-2">LA ENTIDAD implementa medidas administrativas, técnicas y físicas:</p>
              <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                <li>Encriptación</li>
                <li>Tokenización</li>
                <li>Servidores seguros</li>
                <li>Control de accesos</li>
                <li>Monitoreo permanente</li>
                <li>Auditorías internas</li>
                <li>Protocolos antifraude</li>
                <li>Personal obligado a confidencialidad aún después de terminar relación laboral</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">7. Medios para Limitar el Uso o Divulgación</h3>
              <p className="text-[#E0E0E2]">
                Puede solicitar la limitación del uso de sus datos enviando un correo a: [CORREO DEL OPERADOR]
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">8. Derechos ARCO</h3>
              <p className="text-[#E0E0E2] mb-2">
                Usted puede ejercer sus derechos enviando una solicitud a: [CORREO ELECTRÓNICO]
              </p>
              <p className="text-[#E0E0E2] mb-2">Incluya:</p>
              <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                <li>Identificación</li>
                <li>Descripción de la solicitud</li>
                <li>Datos relacionados</li>
                <li>Medio para recibir la respuesta</li>
              </ul>
              <p className="text-[#E0E0E2] mt-2">
                El plazo de respuesta es de 20 días hábiles.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">9. Uso de Cookies y Tecnologías</h3>
              <p className="text-[#E0E0E2] mb-2">Utilizamos cookies para:</p>
              <ul className="list-disc list-inside space-y-1 text-[#E0E0E2] ml-4">
                <li>Validar sesión</li>
                <li>Mejorar experiencia de usuario</li>
                <li>Realizar análisis estadísticos</li>
                <li>Prevenir fraude</li>
                <li>Funciones operativas internas</li>
              </ul>
              <p className="text-[#E0E0E2] mt-2">
                Puede deshabilitarlas desde su navegador.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">10. Cambios al Aviso de Privacidad</h3>
              <p className="text-[#E0E0E2]">
                El Operador podrá modificar este Aviso y publicará la versión actualizada en la plataforma.
              </p>
            </section>

            <section className="space-y-4">
              <h3 className="text-lg font-bold text-white mt-6">11. Contacto</h3>
              <div className="space-y-2 text-[#E0E0E2]">
                <p><strong>Correo:</strong> [CORREO DEL OPERADOR]</p>
                <p><strong>Domicilio:</strong> [DOMICILIO COMPLETO]</p>
                <p><strong>Fecha de última actualización:</strong> [FECHA]</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;

